module.exports = __webpack_public_path__ + "static/media/search-icon.9d3d916b.png";